import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import ROUTES from 'constants/ROUTES';
import EVENTS from 'constants/EVENTS';
import { useLandbotContext } from 'context/landbot.context';

export default function useActsManager() {
  const { landbot } = useLandbotContext();
  const history = useHistory();

  useEffect(() => {
    if (landbot) {
      const onAct2 = () => history.push(ROUTES.GAME.ACT_2);
      const onAct3 = () => history.push(ROUTES.GAME.ACT_3);
      const onAct4 = () => history.push(ROUTES.GAME.ACT_4);
  
      landbot.events.on(EVENTS.ACT_2, onAct2);
      landbot.events.on(EVENTS.ACT_3, onAct3);
      landbot.events.on(EVENTS.ACT_4, onAct4);
  
      return () => {
        landbot.events.off(EVENTS.ACT_2, onAct2);
        landbot.events.off(EVENTS.ACT_3, onAct3);
        landbot.events.off(EVENTS.ACT_4, onAct4);
      };
    }
  }, [landbot]);
}